import type {
  UpdateUserProjectNotificationSettingInput,
  UserProjectNotificationSetting,
} from "schemas/generated/userProjectNotificationSettings";
import type { RequestFn } from "./request";

export function createUserProjectNotificationSettingsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    find: ({ projectId }: { projectId: string }) => {
      return request<UserProjectNotificationSetting[]>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/user-project-notification-settings`,
      });
    },
    update: ({
      projectId,
      ...input
    }: { projectId: string } & UpdateUserProjectNotificationSettingInput) => {
      return request<UserProjectNotificationSetting[]>({
        method: "PATCH",
        path: `/api/v1/projects/${projectId}/user-project-notification-settings`,
        body: input,
      });
    },
  };
}
